import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {} from "@fortawesome/free-solid-svg-icons";
import Icon from "./facebook-brands.svg";
class Footer extends React.Component {
    render() {
        return (
            <div>
                {/* footer */}
                <div className="footer-ads">
                    <div className="ads-img">
                        <img
                            src="https://statics.olx.com.pk/external/base/img/phone-app.png"
                            alt=""
                        />
                    </div>
                    <div className="title">
                        <h1>TRY THE OLX APP</h1>
                        <br />
                        <p>
                            Buy, sell and find just about anything using <br />
                            the app on your mobile.
                        </p>
                    </div>
                    <div className="hr-line" />
                    <div className="app-store">
                        <div className="app-title">
                            <span>GET YOUR APP TODAY</span>
                        </div>
                        <img
                            className="app-icon"
                            src="https://statics.olx.com.pk/external/base/img/appstore_2x.png"
                            alt="ios-app-store"
                        />
                        <img
                            className="app-icon"
                            src="https://statics.olx.com.pk/external/base/img/playstore_2x.png"
                            alt=""
                        />
                    </div>
                </div>
                {/* main-footer */}
                <footer>
                    <div className="olx-footer">
                        <div className="olx-content">
                            <div className="ul">
                                <section>
                                    <p>POPULAR CATEGORIES</p>
                                    <ul>
                                        <a href>
                                            <li>Cars</li>
                                        </a>
                                        <a href>
                                            <li>Flats for rent</li>
                                        </a>
                                        <a href>
                                            <li>Jobs</li>
                                        </a>
                                        <a href>
                                            <li>Mobile Phoness</li>
                                        </a>
                                    </ul>
                                </section>
                            </div>
                            <div className="ul">
                                <section>
                                    <p>TRENDING SEARCHES</p>
                                    <ul>
                                        <a href>
                                            <li>Cars</li>
                                        </a>
                                        <a href>
                                            <li>Flats for rent</li>
                                        </a>
                                        <a href>
                                            <li>Jobs</li>
                                        </a>
                                        <a href>
                                            <li>Mobile Phoness</li>
                                        </a>
                                    </ul>
                                </section>
                            </div>
                            <div className="ul">
                                <section>
                                    <p>ABOUT US</p>
                                    <ul>
                                        <a href>
                                            <li>Cars</li>
                                        </a>
                                        <a href>
                                            <li>Flats for rent</li>
                                        </a>
                                        <a href>
                                            <li>Jobs</li>
                                        </a>
                                        <a href>
                                            <li>Mobile Phoness</li>
                                        </a>
                                    </ul>
                                </section>
                            </div>
                            <div className="ul">
                                <section>
                                    <p>OLX</p>
                                    <ul>
                                        <a href>
                                            <li>Cars</li>
                                        </a>
                                        <a href>
                                            <li>Flats for rent</li>
                                        </a>
                                        <a href>
                                            <li>Jobs</li>
                                        </a>
                                        <a href>
                                            <li>Mobile Phoness</li>
                                        </a>
                                    </ul>
                                </section>
                            </div>
                            {/* social icons */}
                            <section>
                                <div className="social-icon">
                                    <p>FOLLOW US</p>
                                    <img src={Icon} alt="" />
                                    <img src={Icon} alt="" />
                                    <img src={Icon} alt="" />
                                    <img src={Icon} alt="" />

                                    <div className="social-apps">
                                        <img
                                            src="https://statics.olx.com.pk/external/base/img/appstore.png"
                                            alt="ios-app-store"
                                        />
                                        <img
                                            src="https://statics.olx.com.pk/external/base/img/playstore.png"
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <div className="company-footer">
                        <div className="country">
                            <strong>Other Countries</strong> India - South
                            Africa - Indonesia
                        </div>
                        <div className="olx-pak">
                            <strong>Free Classifieds in Pakistan.</strong> ©
                            2006-2020 OLX
                        </div>
                    </div>
                </footer>
            </div>
        );
    }
}

export default Footer;
